module.exports = __webpack_public_path__ + "img/centered-logo-nav-chevy.2c71aa96.png";